export default __webpack_public_path__ + "static/media/photography_image.bdfa0681.webp";